<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: PrerenderNavigation                                   |
| Section: components/prerender                                    |
| Purpose: Lightweight crawlable navigation for static snapshots.  |
+------------------------------------------------------------------+
-->
<template>
    <nav class="prerender-navigation" :aria-label="$t('nav.mainNavigation')" data-prerender-navigation>
        <a v-for="item in links" :key="item.id" :href="localePath(item.path)">{{ $t(item.labelKey) }}</a>
    </nav>
</template>

<script>
import { PRERENDER_NAVIGATION_LINKS } from '@/config/siteNavigation';
import { useLocale } from '@/composables/useLocale';

export default {
    name: 'PrerenderNavigation',
    setup() {
        const { localePath } = useLocale();
        return {
            links: PRERENDER_NAVIGATION_LINKS,
            localePath,
        };
    },
};
</script>

<style scoped>
.prerender-navigation {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px 20px;
    padding: 24px;
    border-bottom: 1px solid #ece8e4;
    background: #fff;
}

.prerender-navigation a {
    color: #242424;
    font-weight: 600;
}
</style>
